var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "-7 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 25.6c-0.12 0-0.2-0.040-0.32-0.080-0.32-0.12-0.52-0.44-0.52-0.8v-2.8h-3.72c-0.48 0-0.84-0.4-0.84-0.84v-13.84c0-0.48 0.4-0.84 0.84-0.84h16.24c0.48 0 0.84 0.4 0.84 0.84v10.92c0 0.24-0.080 0.44-0.24 0.6l-2.92 2.92c-0.16 0.16-0.36 0.24-0.6 0.24h-4.84l-3.32 3.4c-0.12 0.2-0.36 0.28-0.6 0.28zM1.72 20.24h3.72c0.48 0 0.84 0.4 0.84 0.84v1.56l2.080-2.16c0.16-0.16 0.4-0.24 0.6-0.24h4.84l2.4-2.4v-9.72h-14.48v12.12zM8.68 16v-4.12c0-0.48-0.4-0.84-0.84-0.84s-0.84 0.4-0.84 0.84v4.12c0 0.48 0.4 0.84 0.84 0.84s0.84-0.36 0.84-0.84zM13.080 16v-4.12c0-0.48-0.4-0.84-0.84-0.84s-0.84 0.4-0.84 0.84v4.12c0 0.48 0.4 0.84 0.84 0.84s0.84-0.36 0.84-0.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.7fb0a4a251f707c7fe7a91b033220f9f.svg";
export { ForwardRef as ReactComponent };